const COMPOSER_DRAFT_CONTEXT_KIND_VALUES = new Set(['thread', 'new-thread', 'schedule-builder', 'trigger-builder', 'workflow-builder']);

const normalizeComposerDraftEntry = (payload = {}) => {
  const contextKey = String(payload?.context?.contextKey || payload?.contextKey || '').trim();
  const value = String(payload?.value || '');

  if (!contextKey) {
    return null;
  }

  if (!value) {
    return {
      contextKey,
      value: ''
    };
  }

  const kind = String(payload?.context?.kind || payload?.kind || '')
    .trim()
    .toLowerCase();
  const normalizedKind = COMPOSER_DRAFT_CONTEXT_KIND_VALUES.has(kind) ? kind : 'thread';
  const threadId = String(payload?.context?.threadId || payload?.threadId || '').trim() || null;
  const projectId = String(payload?.context?.projectId || payload?.projectId || '').trim() || null;

  return {
    contextKey,
    kind: normalizedKind,
    threadId,
    projectId,
    value,
    updatedAt: Date.now()
  };
};

export default normalizeComposerDraftEntry;
